<template>
  <div class="cards-secretaria">
    <div class="row">
      <div class="col-xs-12">
        <h2>Dados por Secretaria Municipal</h2>
        <p>
          Você também pode visualizar os dados por secretaria. Basta acessá-los
          pelos cards abaixo:
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 secretarias">
        <div class="card-secretaria" v-for="({ isAutarquia, codigo, nome }) in secretarias" :key="codigo" >
          <router-link
            :to="{
              name: 'listar_dados_secretaria',
              query: isAutarquia ? { autarquias: codigo } : { secretarias: codigo }
            }"
          >
            <div class="paragrafo">
              <p class="text-lg">
                {{ nome }}
              </p>
              <div v-if="nome === 'Todas as Metas'">
                <img
                  :src="logo"
                  :alt="'imagem representando todas as metas'"
                  class="imgPMS"
                />
              </div>
              <hr v-else />
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    secretarias: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      imgUrl: this.$root.$data.imgUrl,
      logo: require('@/assets/css/img/brasao-cor-branco-vertical.svg')
    }
  }
}
</script>

<style scoped>
.imgPMS {
  height: 100%;
  position: relative;
  top: -10px;
}

.secretarias {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  align-content: stretch;
}

.card-secretaria {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 18rem;
  min-height: 16rem;
  background-color: #324128;
  transition: all 0.2s ease;
}
.card-secretaria:hover {
  transform: scale(0.95);
}

.paragrafo > p {
  color: #fff;
  font-weight: 600;
  margin-bottom: 10px;
  font-style: italic;
  padding: 5px;
}
.paragrafo > hr {
  margin: 0 20px;
}

.paragrafo > hr {
  border-image: linear-gradient(to right, #324128 0%, #bddb70 100%) 1;
  border-style: solid;
  border-width: 1px;
}

/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {
  .secretarias {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CardsODS/CardsSecretaria.vue